import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";

export const ContactSeller = () => {
  const [contactList, setContactList] = useState([]);
  const [products, setProducts] = useState([]);
  const [users, setUsers] = useState([]);

  // ───────────────────────────────
  // FETCH ALL DATA
  // ───────────────────────────────
  useEffect(() => {
    fetchContacts();
    fetchProducts();
    fetchUsers();
  }, []);

  const fetchContacts = async () => {
    try {
      const res = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_contact_supplier"
      );
      if (res.data.success === "1") {
        setContactList(res.data.data);
      }
    } catch (err) {
      toast.error("Failed to load contacts");
    }
  };

  const fetchProducts = async () => {
    try {
      const res = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_create_product"
      );
      if (res.data.success === "1") {
        setProducts(res.data.data);
      }
    } catch (err) {
      toast.error("Failed to load products");
    }
  };

  const fetchUsers = async () => {
    try {
      const res = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/user_list"
      );
      if (res.data.success === "1") {
        setUsers(res.data.data);
      }
    } catch (err) {
      toast.error("Failed to load users");
    }
  };

  // ───────────────────────────────
  // HELPERS
  // ───────────────────────────────
  const getProductName = (id) =>
    products.find((p) => p.product_id === id)?.product_name || "—";

  const getUserName = (id) =>
    users.find((u) => u.user_id === id)?.name || "—";

  // ───────────────────────────────
  // DELETE CONTACT
  // ───────────────────────────────
  const deleteContact = async (id) => {
    try {
    //   const formData = new FormData();
    //   formData.append("contact_supplier_id", id);

      const res = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/delete_contact_supplier",
        {contact_supplier_id: id}
      );

      if (res.data.success === "1") {
        toast.error(res.data.message);
        setContactList((prev) =>
          prev.filter((item) => item.contact_supplier_id !== id)
        );
      }
    } catch (err) {
      toast.error("Delete failed");
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">

        <h4 className="mb-3 fw-semibold">Contact Supplier List</h4>

        <div className="card">
          <div className="table-responsive">
            <table className="table table-hover align-middle">
              <thead className="bg-light-subtle">
                <tr>
                  <th>#</th>
                  <th>Product</th>
                  <th>Customer</th>
                  <th>Subject</th>
                  <th>Date</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {contactList.map((item, index) => (
                  <tr key={item.contact_supplier_id}>
                    <td>{index + 1}</td>
                    <td>{getProductName(item.product_id)}</td>
                    <td>{getUserName(item.user_id)}</td>
                    <td>{item.subject}</td>
                    <td>{item.created_at}</td>
                    <td className="d-flex gap-2">
                      <Link
                        to={`/seller-contact-view/${item.contact_supplier_id}`}
                        className="btn btn-soft-primary btn-sm"
                      >
                        <i className="fa-solid fa-eye"></i>
                      </Link>

                      <button
                        onClick={() =>
                          deleteContact(item.contact_supplier_id)
                        }
                        className="btn btn-soft-danger btn-sm"
                      >
                        <i className="fa-solid fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))}

                {contactList.length === 0 && (
                  <tr>
                    <td colSpan="6" className="text-center text-muted">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  );
};


export const ContactView = () => {
  const { id } = useParams();

  const [contact, setContact] = useState(null);
  const [product, setProduct] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    fetchContact();
  }, [id]);

  const fetchContact = async () => {
    const formData = new FormData();
    formData.append("contact_supplier_id", id);

    const res = await axios.post(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_by_id_contact_supplier",
      formData
    );

    if (res.data.success === "1") {
      const data = res.data.data[0];
      setContact(data);
      fetchProduct(data.product_id);
      fetchUser(data.user_id);
    }
  };

  const fetchProduct = async (productId) => {
    const res = await axios.get(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_create_product"
    );
    setProduct(res.data.data.find((p) => p.product_id === productId));
  };

  const fetchUser = async (userId) => {
    const res = await axios.get(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/user_list"
    );
    setUser(res.data.data.find((u) => u.user_id === userId));
  };

  if (!contact) return null;

  return (
    <div className="page-content">
      <div className="container-fluid">

        <div className="card p-4">
          <div className="d-flex justify-content-between">
            <h4>Contact Supplier View</h4>
            <Link to="/seller-contact">
              <i className="fa-solid fa-circle-xmark fs-22"></i>
            </Link>
          </div>

          <p><strong>Product:</strong> {product?.product_name}</p>
          <p><strong>Customer:</strong> {user?.name}</p>
          <p><strong>Subject:</strong> {contact.subject}</p>
          <p><strong>Message:</strong> {contact.your_problem}</p>
          <p><strong>Date:</strong> {contact.created_at}</p>

          <div className="mt-3">
            <strong>Images</strong>
            <div className="d-flex gap-3 mt-2 flex-wrap">
              {contact.multi_image?.map((img, i) => (
                <img
                  key={i}
                  src={`https://cyberathon.com/multivendor/${img}`}
                  width={200}
                  height={150}
                  style={{ objectFit: "cover" }}
                  alt="contact"
                />
              ))}
            </div>
          </div>

        </div>

      </div>
    </div>
  );
};
